import { Component, Fragment } from "react";

class Strategy4LogsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: []
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.getLogs();
    }
  }

  getLogs = async () => {
    if (this.props.conditionId) {
      const json = await this.props.getConditionLogs(this.props.conditionId);
      if (json.type === "success") {
        this.setState({ logs: json.logs });
      }
    }
  }

  render() {
    const logs = [];

    this.state.logs.map((log, i) => {
      if (log.level === "ERROR") {
        logs.push(
          <Fragment key={i}>
            <code className="error-log has-background-black-ter">{`${log.timestamp} [ERROR] ${log.text} (#${log.strategyNum})`}</code>
            <br />
          </Fragment>
        );
      } else if (log.level === "SUCCESS") {
        logs.push(
          <Fragment key={i}>
            <code className="success-log has-background-black-ter">{`${log.timestamp} [SUCCESS] ${log.text} (#${log.strategyNum})`}</code>
            <br />
          </Fragment>
        );
      } else if (log.level === "INFO") {
        logs.push(
          <Fragment key={i}>
            <code className="info-log has-background-black-ter">{`${log.timestamp} [INFO] ${log.text} (#${log.strategyNum})`}</code>
            <br />
          </Fragment>
        );
      }
      return null;
    });

    return (
      <div className={this.props.show ? "modal is-active" : "modal"}>
        <div className="modal-background" onClick={this.props.handleClose}></div>

        <div className="modal-card wide-modal">
          <header className="modal-card-head">
            <h5 className="modal-card-title">Logs (Condition #{this.props.conditionId})</h5>
            <button className="delete" onClick={this.props.handleClose}></button>
          </header>

          <section className="modal-card-body overflow-auto">
            <div className="columns is-mobile">
              <span className="column is-full py-0">
                <button className="button is-fullwidth is-info" onClick={this.getLogs}>Refresh</button>
              </span>
            </div>

            <hr />

            <div className="has-background-black-ter has-text-white p-2">
              {logs}
            </div>
          </section>

          <footer className="modal-card-foot"></footer>
        </div>
      </div>
    );
  }
}

export default Strategy4LogsModal;
